<template>
<!--
  There are 2 differences between this and App
  1. allowSendToDispatchTrack prop in Waves is false
  2. Routing tab is not rendered

  There's probably a better way to DRY this up,
  but this worked in a pinch
-->
  <div id="app">
    <br />
    <br />
    <h3>Manage Crossdock Deliveries</h3>
    <div class="app__actions">
      <div class="app__datepicker">
        <PickDate v-model="pickDate"/>
      </div>
      <div class="app__refresh">
        <btn @click="handleRefreshClick">Refresh</btn>
      </div>
    </div>
    <div class="app__table">
      <div v-if="$apollo.queries.orders.loading">
        <Spinner message="Loading order data... Please wait" />
      </div>
      <div v-else-if="errors.length > 0">
        <h4>We're sorry, an unexpected error occurred</h4>
        <ul>
          <li v-for="error in errors" :key="error" >{{error}}</li>
        </ul>
      </div>
      <div v-else-if="orders.length === 0">
        <h4>There aren't any orders here yet</h4>
        <p>Once orders get added to the system for this date, they will show up here.</p>
      </div>
      <div v-else>
        <br>
        <tabs v-model="tabIndex" pills justified>
          <tab title="Pending">
            <br>
            <Pending :pickDate="pickDate" :orders="orders"/>
          </tab>
          <tab title="Waves">
            <br>
            <Waves :pickDate="pickDate" :orders="orders" :allowSendToDispatchTrack="false"/>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getOrders } from '@/queries';
import { Pending, Waves } from '@/views';

export default {
  name: 'App',
  components: {
    Pending,
    Waves
  },
  data() {
    return {
      errors: [],
      orders: [],
      tabIndex: 0,
      pickDate: moment().format('YYYY-MM-DD')
    };
  },
  apollo: {
    orders: {
      query: getOrders,
      variables() {
        return {
          pickDate: this.pickDate
        };
      },
      error({ networkError, graphQLErrors }) {
        if (networkError) {
          this.errors.push('There was a network error. Please try refreshing again.')
        }
        if (graphQLErrors.length > 0) {
          graphQLErrors.forEach(error => {
            this.errors.push(error.message)
          })
        }
      }
    },
  },
  methods: {
    async handleRefreshClick() {
      if (this.errors.length > 0) {
        this.errors = [];
        await this.$apollo.queries.orders.refresh();
      } else {
        await this.$apollo.queries.orders.refetch();
      }
    }
  }
};
</script>

<style>
.app__actions {
  display: flex;
  justify-content: space-between;
}

.app__datepicker {
  display: inline-block;
}

.app__refresh {
  display: inline-block;
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/CrossdockApp.vue